class RegistrationContactsBlockController {
  constructor () {
    'ngInject'
  }

}

export default RegistrationContactsBlockController



// WEBPACK FOOTER //
// ./src/app/pages/registration/common/registration-contacts-block/registration-contacts-block.controller.js